import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-xl font-semibold text-background-50 mb-4">
              AllChinaBuy Spreadsheet
            </h3>
            <p className="text-sm text-background-300 leading-relaxed mb-6">
              {t('footer_disclaimer')}
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-background-800/50 flex items-center justify-center hover:bg-background-700 transition-colors">
                <i className="ri-global-line text-background-200" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800/50 flex items-center justify-center hover:bg-background-700 transition-colors">
                <i className="ri-twitter-x-line text-background-200" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800/50 flex items-center justify-center hover:bg-background-700 transition-colors">
                <i className="ri-instagram-line text-background-200" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              {t('footer_links')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('nav_spreadsheet')}</a>
              </li>
              <li>
                <a href="/allchinabuy-spreadsheet-guide" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('nav_guides')}</a>
              </li>
              <li>
                <a href="/" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('nav_reviews')}</a>
              </li>
              <li>
                <a href="/" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('footer_about')}</a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              {t('footer_resources')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('nav_shipping')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('nav_qc')}</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('popular_coupon')}</a>
              </li>
              <li>
                <a href="/allchinabuy-spreadsheet-guide" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('popular_warehouse')}</a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              {t('footer_legal')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('footer_privacy')}</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('footer_terms')}</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('footer_disclaimer_link')}</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors">{t('footer_contact')}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            {t('footer_copyright')}
          </p>
          <p className="text-xs text-background-400">
            Independent resource — not affiliated with AllChinaBuy
          </p>
        </div>
      </div>
    </footer>
  );
}